import { useState, useEffect } from "react";
import { SwiperSlide } from "swiper/react"
import { imageurl, imgCheck } from "../Utils/fn";
import img from "./../../assets/banner-placeholder.png"
import { Skeleton } from "@mui/material";

const Singleslider = ({ slider }) => {
    const [thumbnail, setThumbnail] = useState(null);

    useEffect(() => {
        slider?.imageName && imgCheck(imageurl(slider.imageName, img)).then((src) => setThumbnail(src))
    }, [slider.imageName]);


    return (
        <div className="wrapsliderimage">
            {thumbnail ?
                <img src={thumbnail} className="hometopbannerimg" /> :
                <Skeleton variant="rectangular" sx={{ height: 200, width: 300, borderRadius: 2 }} />
            }
        </div>
    )
}
export default Singleslider